import type { HTMLAttributes } from "react";

import type {
  TAnimatedHorizontalRuleBackground,
} from "@/ui/components/layout/AnimatedHorizontalRule";
import type { TIllustrationKey } from "@/ui/components/primitives/Illustration";
import type { TButtonProps } from "@/ui/components/primitives/Button";

/*-------------------------------------
|  Constants
|-------------------------------------*/

export const ANIMATED_HEADER_SPLASH_DEFAULTS = {
  illustration: "hideInBox",
  background: {
    top: "bg-sys-white",
    bottom: "bg-sys-blue-600",
  },
} as const;

/*-------------------------------------
|  Types
|-------------------------------------*/

export type TAnimatedHeaderSplashButtons = {
  primary: TButtonProps;
  secondary?: TButtonProps;
};

export type TAnimatedHeaderSplashProps = {
  title: string;
  buttons: TAnimatedHeaderSplashButtons;
  illustration?: TIllustrationKey;
  background?: TAnimatedHorizontalRuleBackground;
  containerClassName?: string;
} & HTMLAttributes<HTMLElement>;
